module.exports = __webpack_public_path__ + "static/img/son4.e47a3b1d.png";